module.exports = __webpack_public_path__ + "static/media/planet.82bde5c8.png";